module.exports = __webpack_public_path__ + "static/f4b706ba.radio1.png";